import { Plugin } from '@nuxt/types';

import type { KilkayaWindow } from '@root/modules/kilkaya/types/kilkaya';

declare const window: KilkayaWindow;

/** Keeps window.k5aMeta in sync with Piano access state for Kilkaya stream variant selection. */
const kilkayaMeta: Plugin = async (ctx) => {
  const { app, store } = ctx;
  const route = app.router!.currentRoute;

  const { frontpage } = app.$channelConfig('page');
  if (!frontpage.kilkaya && typeof route.query.k5a !== 'string') {
    return;
  }

  const { id } = app.$channelConfig('settings');

  function applyK5aMeta() {
    const channelAccess = store.state.piano.access.channelAccess;
    const adFree = store.state.piano.access.adFree;

    window.k5aMeta = {
      ...window.k5aMeta,
      section: id,
      subscriber: Number(channelAccess),
      ...(adFree ? { contentTag: ['adfree'] } : { contentTag: [] }),
    };
  }

  applyK5aMeta();

  store.watch(
    () => [store.state.piano.access.channelAccess, store.state.piano.access.adFree],
    () => applyK5aMeta()
  );
};

export default kilkayaMeta;
